<template>
<xm-modal
  title="Update Password"
  size="lg"
  save-text="Change password"
  :save="changePassword"
  :save-disabled="changePasswordDisabled"
  id="change-password-modal">
  <div>
    <password-form :require-old-password="true" :password-in-modal="true" @input="setPasswordDetails" @form-state="setPasswordDetailsValid"/>
  </div>
</xm-modal>
</template>

<script>
  import FormValidator from '../FormValidator.vue'
  import XmModal from './XmModal.vue'
  import * as types from '../../store/mutation-types'
  import PasswordForm from "../PasswordForm.vue";

  export default {
    data () {
      return {
        modalName: 'change-password',
        passwordDetails: null,
        passwordDetailsValid: false,
        formValid: false,
        changingPassword: false,
        passwordSuccessMessage: 'Your password has been successfully changed. You will need to re-login.'
      }
    },

    computed: {
      changePasswordDisabled () {
        return !this.passwordDetailsValid;
      },
    },

    methods: {
      setPasswordDetails(details) {
        this.passwordDetails = details;
      },
      setPasswordDetailsValid(valid) {
        this.passwordDetailsValid = valid;
      },
      changePassword () {
        this.changingPassword = true
        let self = this
        return this.$store.dispatch('changePassword', {
          currentPass: this.passwordDetails.old_password,
          newPass: this.passwordDetails.password
        }).then(() => {
          self.$store.commit(types.ADD_NOTIFICATION, {type: 'success', message: self.passwordSuccessMessage});
          self.$store.dispatch('logout', self.$router);
          self.changingPassword = false;
        }).catch((error) => {
          self.changingPassword = false;
          return reject(error);
        })
      },
    },
    components: {
      PasswordForm,
      FormValidator,
      XmModal,
    }
  }
</script>



// WEBPACK FOOTER //
// ChangePasswordModal.vue?3dcecc78